const env = {
    BACKEND_BASE_URL: 'https://radish.bikeparkbox.de'
}

export default env
  